export default __webpack_public_path__ + "static/slider-5-c57b6f3e29b56d76f2563250b1c9ceb2.jpg";